// Get the number from the string
// Allow - and . for negative numbers and decimals
export const isNumberString = (value: string) => {
  const regex = /^-?\d*\.?\d*$/;
  return regex.test(value);
};
